import Vue from 'vue'
import Router from 'vue-router'
import ClientsList from '@/components/ClientsList.vue'
import ClientView from '@/components/ClientView.vue'
import ChangePassword from '@/components/ChangePassword.vue'
import AutoScreenshots from '@/components/AutoScreenshots'
import BugTracker from '@/components/BugTracker'
import DueTasks from '@/components/DueTasks'
import PreviewScreenshots from '@/components/PreviewScreenshots'
import Quoting from '@/components/Quoting'
import AddMissingLinks from '@/components/AddMissingLinks'
import LogIn from '@/components/LogIn'
import Home from '@/components/Home'
import SocialAdd from '@/components/SocialAdd'

Vue.use(Router)

var router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/clients',
      name: 'ClientsList',
      component: ClientsList,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/client/:id/add-socials',
      name: 'SocialAdd',
      component: SocialAdd
    },
    {
      path: '/client/:id',
      name: 'ClientView',
      component: ClientView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasks',
      name: 'DueTasks',
      component: DueTasks,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/change-password',
      name: 'ChangePassword',
      component: ChangePassword,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/bugtracker',
      name: 'BugTracker',
      component: BugTracker,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/autoscreenshots',
      name: 'AutoScreenshots',
      component: AutoScreenshots,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/quoting',
      name: 'Quoting',
      component: Quoting,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/addmissinglinks/:id',
      name: 'AddMissingLinks',
      component: AddMissingLinks,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/previewscreenshots/:ids',
      name: 'PreviewScreenshots',
      component: PreviewScreenshots,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'LogIn',
      component: LogIn
    },
    

  ]
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  // redirect to change password page if logged in but with a default password
  if(to.matched.some(record => record.meta.requiresAuth)) {
    const loggedIn = localStorage.getItem('user');
    
    if(!loggedIn) {
      return next('/login');
    }
    else if(JSON.parse(loggedIn).expiredPass && to.name !== "ChangePassword") {
      return next('/change-password');
    }
    else {
      return next();
    }
  }
  else {
    return next();
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js